export default __webpack_public_path__ + "static/media/tirza1.c950b626.jpg";